var map = {
	"./bh-ico-active.svg": 1790,
	"./bh-ico.svg": 1791,
	"./bonus-ico-active.svg": 1792,
	"./bonus-ico.svg": 1793,
	"./deposit-ico.svg": 1794,
	"./deposit-ico.webp": 1795,
	"./edit-icon.svg": 1796,
	"./fb-ico.svg": 1797,
	"./instant-rebate-ico-active.svg": 1798,
	"./instant-rebate-ico.svg": 1799,
	"./mall-ico-active.svg": 1800,
	"./mall-ico.svg": 1801,
	"./msg-ico-active.svg": 1802,
	"./msg-ico.svg": 1803,
	"./pi-ico-active.svg": 1804,
	"./pi-ico.svg": 1805,
	"./rf-ico-active.svg": 1806,
	"./rf-ico.svg": 1807,
	"./rh-ico-active.svg": 1808,
	"./rh-ico.svg": 1809,
	"./th-ico-active.svg": 1810,
	"./th-ico.svg": 1811,
	"./vip-ico-active.svg": 1812,
	"./vip-ico.svg": 1813,
	"./withdrawal-ico.svg": 1814,
	"./withdrawal-ico.webp": 1815,
	"./wl-ico-active.svg": 1816,
	"./wl-ico.svg": 1817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 472;